import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchDashboardStatisticsRoutine } from 'features/dashboard/ducks/actions'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'
import { useComplianceChanged } from 'utils/complianceEvents'

export const useDashboardStats = ({ altitude, entityId, assigneeId, origin, from, to }) => {
  const dispatch = useDispatch()
  const loadStats = useCallback(() => {
    if (checkIsOnline()) {
      dispatch(fetchDashboardStatisticsRoutine({ altitude, entityId, assigneeId, origin, from, to }))
    }
  }, [dispatch, altitude, entityId, assigneeId, origin, from, to])

  useEffect(() => { loadStats() }, [loadStats])
  useComplianceChanged(loadStats)

  return loadStats
}
